import { toImagePath } from "@/shared/helpers/to-image-path.helper";

import activeMarkerImage from "./assets/active-marker.png";
import activeNeedInfoMarkerImage from "./assets/active-need-info-marker.png";
import activePinElementaryMiddleHighImage from "./assets/active-pin-elementary-middle-high.png";
import activePinElementaryMiddleImage from "./assets/active-pin-elementary-middle.png";
import activePinElementarySchoolImage from "./assets/active-pin-elementary-school.png";
import activePinHighSchoolImage from "./assets/active-pin-high-school.png";
import activePinK8SchoolImage from "./assets/active-pin-k-8-school.png";
import activePinK8HighImage from "./assets/active-pin-k8-high.png";
import activePinMiddleHighImage from "./assets/active-pin-middle-high.png";
import activePinMiddleSchoolImage from "./assets/active-pin-middle-school.png";
import activePinSchoolInactiveImage from "./assets/active-pin-school-inactive.png";
import activeReadyToConfirmMarkerImage from "./assets/active-ready-to-confirm-marker.png";
import hoverMarkerImage from "./assets/hover-marker.png";
import hoverNeedInfoMarkerImage from "./assets/hover-need-info-marker.png";
import hoverPinElementaryMiddleHighImage from "./assets/hover-pin-elementary-middle-high.png";
import hoverPinElementaryMiddleImage from "./assets/hover-pin-elementary-middle.png";
import hoverPinElementarySchoolImage from "./assets/hover-pin-elementary-school.png";
import hoverPinHighSchoolImage from "./assets/hover-pin-high-school.png";
import hoverPinK8SchoolImage from "./assets/hover-pin-k-8-school.png";
import hoverPinK8HighImage from "./assets/hover-pin-k8-high.png";
import hoverPinMiddleHighImage from "./assets/hover-pin-middle-high.png";
import hoverPinMiddleSchoolImage from "./assets/hover-pin-middle-school.png";
import hoverPinSchoolInactiveImage from "./assets/hover-pin-school-inactive.png";
import hoverReadyToConfirmMarkerImage from "./assets/hover-ready-to-confirm-marker.png";
import markerImage from "./assets/marker.png";
import needInfoMarkerImage from "./assets/need-info-marker.png";
import pinElementaryMiddleHighImage from "./assets/pin-elementary-middle-high.png";
import pinElementaryMiddleImage from "./assets/pin-elementary-middle.png";
import pinElementarySchoolImage from "./assets/pin-elementary-school.png";
import pinHighSchoolImage from "./assets/pin-high-school.png";
import pinK8SchoolImage from "./assets/pin-k-8-school.png";
import pinK8HighImage from "./assets/pin-k8-high.png";
import pinMiddleHighImage from "./assets/pin-middle-high.png";
import pinMiddleSchoolImage from "./assets/pin-middle-school.png";
import pinSchoolInactiveImage from "./assets/pin-school-inactive.png";
import readyToConfirmMarkerImage from "./assets/ready-to-confirm-marker.png";
import searchMarkerImage from "./assets/search-marker.png";
import darkPreview from "./assets/styles-previews/dark.png";
import hybridPreview from "./assets/styles-previews/hybrid.png";
import lightPreview from "./assets/styles-previews/light.png";
import satellitePreview from "./assets/styles-previews/satellite.png";
import streetsPreview from "./assets/styles-previews/streets.png";
import { MapStyle } from "./enums/map-style.enum";

import type {
  MapCoordinates,
  MapStyleOption,
  PolygonStrokeStyle,
} from "./types";

// Map IDs
export const PLOTS_SOURCE_ID = "plots-source";
export const PLOTS_LAYER_ID = "plots-layer";
export const ACTIVE_PLOT_RING_1_LAYER_ID = "plots-active-ring-1";
export const ACTIVE_PLOT_RING_2_LAYER_ID = "plots-active-ring-2";

export const MARKERS_SOURCE_ID = "markers-source";
export const MARKERS_LAYER_ID = "markers-layer";
export const MARKERS_ACTIVE_LAYER_ID = "markers-active-layer";
export const MARKERS_LABEL_LAYER_ID = "markers-label-layer";

export const POLYGONS_SOURCE_ID = "polygons-source";
export const POLYGONS_LAYER_ID = "polygons-layer";
export const POLYGONS_OUTLINE_LAYER_ID = "polygons-layer-outline";
export const POLYGONS_SOURCE_LAYER_ID = "districts_map_layer";

export const ELEMENTARY_DISTRICTS_SOURCE_ID = "elementary-districts-source";
export const ELEMENTARY_DISTRICTS_LAYER_ID = "elementary-districts-layer";
export const ELEMENTARY_DISTRICTS_OUTLINE_LAYER_ID =
  "elementary-districts-layer-outline";
export const ELEMENTARY_DISTRICTS_SOURCE_LAYER_ID =
  "elementary_districts_map_layer";

export const SECONDARY_DISTRICTS_SOURCE_ID = "secondary-districts-source";
export const SECONDARY_DISTRICTS_LAYER_ID = "secondary-districts-layer";
export const SECONDARY_DISTRICTS_OUTLINE_LAYER_ID =
  "secondary-districts-layer-outline";
export const SECONDARY_DISTRICTS_SOURCE_LAYER_ID =
  "secondary_districts_map_layer";

export const SCHOOL_BOUNDARIES_SOURCE_ID = "school_boundaries_source";
export const SCHOOL_BOUNDARIES_LAYER_ID = "school_boundaries_layer";
export const SCHOOL_BOUNDARIES_SOURCE_LAYER_ID = "school_boundaries_map_layer";
export const SCHOOL_BOUNDARIES_OUTLINE_LAYER_ID =
  "school_boundaries_level_map_layer_outline";

export const SCHOOL_BOUNDARIES_LEVEL_SOURCE_ID =
  "school_boundaries_level_source";
export const SCHOOL_BOUNDARIES_LEVEL_LAYER_ID = "school_boundaries_level_layer";
export const SCHOOL_BOUNDARIES_LEVEL_SOURCE_LAYER_ID =
  "school_boundaries_level_map_layer";
export const SCHOOL_BOUNDARIES_LEVEL_OUTLINE_LAYER_ID =
  "school_boundaries_level_map_layer_outline";

export const SCHOOL_PINS_SOURCE_ID = "school_pins_source";
export const SCHOOL_PINS_LAYER_ID = "school_pins_layer";
export const SCHOOL_PINS_SOURCE_LAYER_ID = "school_pins_map_layer";
export const SCHOOL_PINS_CLUSTER_SOURCE_LAYER_ID =
  "school_pins_cluster_map_layer";
export const SCHOOL_PINS_ACTIVE_LAYER_ID = "school_pins_active_layer";
export const SCHOOL_PINS_LABEL_LAYER_ID = "school_pins_label_layer";

export const MY_DISTRICT_SOURCE_ID = "my_district_source";
export const MY_DISTRICT_LAYER_ID = "my_district_layer";
export const MY_DISTRICT_OUTLINE_LAYER_ID = "my_district_map_layer_outline";

export const ROADS_SOURCE_ID = "maptiler_roads_source";
export const ROADS_LAYER_ID = "maptiler_roads_layer";
export const ROADS_SOURCE_LAYER_ID = "road";

export const STUDENTS_PLOTS_SOURCE_ID = "students_plots_source";
export const STUDENTS_PLOTS_LAYER_ID = "students_plots_layer";
export const STUDENTS_PLOTS_SOURCE_LAYER_ID = "student_pins_map_layer";
export const STUDENTS_PLOTS_CLUSTER_SOURCE_LAYER_ID =
  "student_pins_cluster_map_layer";
export const STUDENTS_PLOTS_ACTIVE_RING_1_LAYER_ID =
  "students_plots_active_ring_1";
export const STUDENTS_PLOTS_ACTIVE_RING_2_LAYER_ID =
  "students_plots_active_ring_2";
export const STUDENT_CLUSTERS_LAYER_ID = "student_clusters_layer";
export const STUDENTS_PLOTS_CLICKABLE_DURING_DRAW_LAYER_IDS = [
  STUDENTS_PLOTS_LAYER_ID,
  STUDENTS_PLOTS_ACTIVE_RING_1_LAYER_ID,
  STUDENTS_PLOTS_ACTIVE_RING_2_LAYER_ID,
  STUDENT_CLUSTERS_LAYER_ID,
] as const;

export const CUSTOM_LAYER_BOUNDARIES_SOURCE_ID =
  "custom_layer_boundaries_source";
export const CUSTOM_LAYER_BOUNDARIES_LAYER_ID = "custom_layer_boundaries_layer";
export const CUSTOM_LAYER_BOUNDARIES_SOURCE_LAYER_ID =
  "custom_layer_boundaries_map_layer";
export const CUSTOM_LAYER_BOUNDARIES_OUTLINE_LAYER_ID =
  "custom_layer_boundaries_map_layer_outline";

export const CUSTOM_LAYER_DISTRICT_BOUNDARIES_SOURCE_ID =
  "custom_layer_district_boundaries_source";
export const CUSTOM_LAYER_DISTRICT_BOUNDARIES_LAYER_ID =
  "custom_layer_district_boundaries_layer";
export const CUSTOM_LAYER_DISTRICT_BOUNDARIES_SOURCE_LAYER_ID =
  "custom_layer_district_boundaries_map_layer";
export const CUSTOM_LAYER_DISTRICT_BOUNDARIES_OUTLINE_LAYER_ID =
  "custom_layer_district_boundaries_map_layer_outline";

export const CUSTOM_LAYER_DRAFT_SOURCE_ID = "custom_layer_draft_source";
export const CUSTOM_LAYER_DRAFT_LAYER_ID = "custom_layer_draft_layer";
export const CUSTOM_LAYER_DRAFT_OUTLINE_LAYER_ID =
  "custom_layer_draft_layer_outline";

/** MapLevel (= Custom Layers upload) working-map / preview tiles + draft overlay. */
export const MAP_LEVEL_BOUNDARIES_SOURCE_ID = "map_level_boundaries_source";
export const MAP_LEVEL_BOUNDARIES_LAYER_ID = "map_level_boundaries_layer";
export const MAP_LEVEL_BOUNDARIES_SOURCE_LAYER_ID =
  "map_level_boundaries_map_layer";
export const MAP_LEVEL_BOUNDARIES_OUTLINE_LAYER_ID =
  "map_level_boundaries_layer_outline";

export const MAP_LEVEL_DRAFT_SOURCE_ID = "map_level_draft_source";
export const MAP_LEVEL_DRAFT_LAYER_ID = "map_level_draft_layer";
export const MAP_LEVEL_DRAFT_OUTLINE_LAYER_ID = "map_level_draft_layer_outline";

export const NEW_HOUSING_BOUNDARIES_SOURCE_ID = "new_housing_boundaries_source";
export const NEW_HOUSING_BOUNDARIES_LAYER_ID = "new_housing_boundaries_layer";
export const NEW_HOUSING_BOUNDARIES_SOURCE_LAYER_ID =
  "project_boundaries_map_layer";
export const NEW_HOUSING_BOUNDARIES_OUTLINE_LAYER_ID =
  "new_housing_boundaries_layer_outline";

export const NEW_HOUSING_PINS_SOURCE_ID = "new_housing_pins_source";
export const NEW_HOUSING_PINS_LAYER_ID = "new_housing_pins_layer";
export const NEW_HOUSING_PINS_SOURCE_LAYER_ID = "project_pins_map_layer";
export const NEW_HOUSING_PINS_CLUSTER_SOURCE_LAYER_ID =
  "project_pins_cluster_map_layer";
export const NEW_HOUSING_PINS_ACTIVE_LAYER_ID = "new_housing_pins_active_layer";
export const NEW_HOUSING_PINS_LABEL_LAYER_ID = "new_housing_pins_label_layer";
export const SCHOOL_CLUSTERS_LAYER_ID = "school_clusters_layer";
export const SCHOOL_PINS_CLICKABLE_DURING_DRAW_LAYER_IDS = [
  SCHOOL_PINS_LAYER_ID,
  SCHOOL_PINS_ACTIVE_LAYER_ID,
  SCHOOL_PINS_LABEL_LAYER_ID,
  SCHOOL_CLUSTERS_LAYER_ID,
] as const;
export const NEW_HOUSING_CLUSTERS_LAYER_ID = "new_housing_clusters_layer";

export const SHAPES_SOURCE_ID = "shapes-source";
export const SHAPES_LAYER_ID = "shapes-layer";
export const SHAPES_OUTLINE_LAYER_ID = "shapes-outline-layer";

export const SEARCH_MARKER_IMAGE_ID = "search-marker-image";
export const SEARCH_MARKER_ACTIVE_IMAGE_ID = "search-marker-active-image";
export const SEARCH_MARKER_HOVER_IMAGE_ID = "search-marker-hover-image";
export const SEARCH_MARKER_IMAGE_PATH: string =
  typeof searchMarkerImage === "string"
    ? searchMarkerImage
    : searchMarkerImage.src;
export const SEARCH_MARKER_HOVER_IMAGE_PATH: string = SEARCH_MARKER_IMAGE_PATH;
export const SEARCH_MARKER_SOURCE_ID = "search-marker-source";
export const SEARCH_MARKER_LAYER_ID = "search-marker-layer";
export const SEARCH_MARKER_ACTIVE_LAYER_ID = "search-marker-active-layer";
export const SEARCH_MARKER_LABEL_LAYER_ID = "search-marker-label-layer";

export const MARKER_IMAGE_ID = "marker-icon";
export const ACTIVE_MARKER_IMAGE_ID = "active-marker-icon";
export const HOVER_MARKER_IMAGE_ID = "hover-marker-icon";
export const MARKER_ICON_SIZE = 24 / 512;
export const ACTIVE_MARKER_ICON_SIZE = 32 / 512;
export const MARKER_IMAGE_PATH: string =
  typeof markerImage === "string" ? markerImage : markerImage.src;
export const ACTIVE_MARKER_IMAGE_PATH: string =
  typeof activeMarkerImage === "string"
    ? activeMarkerImage
    : activeMarkerImage.src;
export const HOVER_MARKER_IMAGE_PATH: string = toImagePath(hoverMarkerImage);

export const READY_TO_CONFIRM_MARKER_IMAGE_ID = "ready-to-confirm-marker-icon";
export const ACTIVE_READY_TO_CONFIRM_MARKER_IMAGE_ID =
  "active-ready-to-confirm-marker-icon";
export const HOVER_READY_TO_CONFIRM_MARKER_IMAGE_ID =
  "hover-ready-to-confirm-marker-icon";
export const READY_TO_CONFIRM_MARKER_IMAGE_PATH: string = toImagePath(
  readyToConfirmMarkerImage,
);
export const ACTIVE_READY_TO_CONFIRM_MARKER_IMAGE_PATH: string = toImagePath(
  activeReadyToConfirmMarkerImage,
);
export const HOVER_READY_TO_CONFIRM_MARKER_IMAGE_PATH: string = toImagePath(
  hoverReadyToConfirmMarkerImage,
);

export const NEED_INFO_MARKER_IMAGE_ID = "need-info-marker-icon";
export const ACTIVE_NEED_INFO_MARKER_IMAGE_ID = "active-need-info-marker-icon";
export const HOVER_NEED_INFO_MARKER_IMAGE_ID = "hover-need-info-marker-icon";
export const NEED_INFO_MARKER_IMAGE_PATH: string =
  toImagePath(needInfoMarkerImage);
export const ACTIVE_NEED_INFO_MARKER_IMAGE_PATH: string = toImagePath(
  activeNeedInfoMarkerImage,
);
export const HOVER_NEED_INFO_MARKER_IMAGE_PATH: string = toImagePath(
  hoverNeedInfoMarkerImage,
);

// School pin assets
export const PIN_ELEMENTARY_SCHOOL_IMAGE_ID = "pin-elementary-school";
export const PIN_ELEMENTARY_SCHOOL_IMAGE_PATH: string = toImagePath(
  pinElementarySchoolImage,
);

export const PIN_HIGH_SCHOOL_IMAGE_ID = "pin-high-school";
export const PIN_HIGH_SCHOOL_IMAGE_PATH: string =
  toImagePath(pinHighSchoolImage);

export const PIN_K8_SCHOOL_IMAGE_ID = "pin-k-8-school";
export const PIN_K8_SCHOOL_IMAGE_PATH: string = toImagePath(pinK8SchoolImage);

/** Pin when school has both K8 and HIGH level associations */
export const PIN_K8_HIGH_IMAGE_ID = "pin-k8-high";
export const PIN_K8_HIGH_IMAGE_PATH: string = toImagePath(pinK8HighImage);

/** Pin when school has both MIDDLE and HIGH level associations */
export const PIN_MIDDLE_HIGH_IMAGE_ID = "pin-middle-high";
export const PIN_MIDDLE_HIGH_IMAGE_PATH: string =
  toImagePath(pinMiddleHighImage);

/** Pin when school has ELEMENTARY, MIDDLE, and HIGH level associations */
export const PIN_ELEMENTARY_MIDDLE_HIGH_IMAGE_ID = "pin-elementary-middle-high";
export const PIN_ELEMENTARY_MIDDLE_HIGH_IMAGE_PATH: string = toImagePath(
  pinElementaryMiddleHighImage,
);

/** Pin when school has ELEMENTARY and MIDDLE (no HIGH) */
export const PIN_ELEMENTARY_MIDDLE_IMAGE_ID = "pin-elementary-middle";
export const PIN_ELEMENTARY_MIDDLE_IMAGE_PATH: string = toImagePath(
  pinElementaryMiddleImage,
);

export const PIN_MIDDLE_SCHOOL_IMAGE_ID = "pin-middle-school";
export const PIN_MIDDLE_SCHOOL_IMAGE_PATH: string =
  toImagePath(pinMiddleSchoolImage);

export const PIN_SCHOOL_INACTIVE_IMAGE_ID = "pin-school-inactive";
export const PIN_SCHOOL_INACTIVE_IMAGE_PATH: string = toImagePath(
  pinSchoolInactiveImage,
);

export const ACTIVE_PIN_ELEMENTARY_SCHOOL_IMAGE_ID =
  "active-pin-elementary-school";
export const ACTIVE_PIN_ELEMENTARY_SCHOOL_IMAGE_PATH: string = toImagePath(
  activePinElementarySchoolImage,
);

export const ACTIVE_PIN_HIGH_SCHOOL_IMAGE_ID = "active-pin-high-school";
export const ACTIVE_PIN_HIGH_SCHOOL_IMAGE_PATH: string = toImagePath(
  activePinHighSchoolImage,
);

export const ACTIVE_PIN_K8_SCHOOL_IMAGE_ID = "active-pin-k-8-school";
export const ACTIVE_PIN_K8_SCHOOL_IMAGE_PATH: string = toImagePath(
  activePinK8SchoolImage,
);

export const ACTIVE_PIN_K8_HIGH_IMAGE_ID = "active-pin-k8-high";
export const ACTIVE_PIN_K8_HIGH_IMAGE_PATH: string =
  toImagePath(activePinK8HighImage);

export const ACTIVE_PIN_MIDDLE_HIGH_IMAGE_ID = "active-pin-middle-high";
export const ACTIVE_PIN_MIDDLE_HIGH_IMAGE_PATH: string = toImagePath(
  activePinMiddleHighImage,
);

export const ACTIVE_PIN_ELEMENTARY_MIDDLE_HIGH_IMAGE_ID =
  "active-pin-elementary-middle-high";
export const ACTIVE_PIN_ELEMENTARY_MIDDLE_HIGH_IMAGE_PATH: string = toImagePath(
  activePinElementaryMiddleHighImage,
);

export const ACTIVE_PIN_ELEMENTARY_MIDDLE_IMAGE_ID =
  "active-pin-elementary-middle";
export const ACTIVE_PIN_ELEMENTARY_MIDDLE_IMAGE_PATH: string = toImagePath(
  activePinElementaryMiddleImage,
);

export const ACTIVE_PIN_MIDDLE_SCHOOL_IMAGE_ID = "active-pin-middle-school";
export const ACTIVE_PIN_MIDDLE_SCHOOL_IMAGE_PATH: string = toImagePath(
  activePinMiddleSchoolImage,
);

export const ACTIVE_PIN_SCHOOL_INACTIVE_IMAGE_ID = "active-pin-school-inactive";
export const ACTIVE_PIN_SCHOOL_INACTIVE_IMAGE_PATH: string = toImagePath(
  activePinSchoolInactiveImage,
);

export const HOVER_PIN_ELEMENTARY_SCHOOL_IMAGE_ID =
  "hover-pin-elementary-school";
export const HOVER_PIN_ELEMENTARY_SCHOOL_IMAGE_PATH: string = toImagePath(
  hoverPinElementarySchoolImage,
);

export const HOVER_PIN_HIGH_SCHOOL_IMAGE_ID = "hover-pin-high-school";
export const HOVER_PIN_HIGH_SCHOOL_IMAGE_PATH: string = toImagePath(
  hoverPinHighSchoolImage,
);

export const HOVER_PIN_K8_SCHOOL_IMAGE_ID = "hover-pin-k-8-school";
export const HOVER_PIN_K8_SCHOOL_IMAGE_PATH: string = toImagePath(
  hoverPinK8SchoolImage,
);

export const HOVER_PIN_K8_HIGH_IMAGE_ID = "hover-pin-k8-high";
export const HOVER_PIN_K8_HIGH_IMAGE_PATH: string =
  toImagePath(hoverPinK8HighImage);

export const HOVER_PIN_MIDDLE_HIGH_IMAGE_ID = "hover-pin-middle-high";
export const HOVER_PIN_MIDDLE_HIGH_IMAGE_PATH: string = toImagePath(
  hoverPinMiddleHighImage,
);

export const HOVER_PIN_ELEMENTARY_MIDDLE_HIGH_IMAGE_ID =
  "hover-pin-elementary-middle-high";
export const HOVER_PIN_ELEMENTARY_MIDDLE_HIGH_IMAGE_PATH: string = toImagePath(
  hoverPinElementaryMiddleHighImage,
);

export const HOVER_PIN_ELEMENTARY_MIDDLE_IMAGE_ID =
  "hover-pin-elementary-middle";
export const HOVER_PIN_ELEMENTARY_MIDDLE_IMAGE_PATH: string = toImagePath(
  hoverPinElementaryMiddleImage,
);

export const HOVER_PIN_MIDDLE_SCHOOL_IMAGE_ID = "hover-pin-middle-school";
export const HOVER_PIN_MIDDLE_SCHOOL_IMAGE_PATH: string = toImagePath(
  hoverPinMiddleSchoolImage,
);

export const HOVER_PIN_SCHOOL_INACTIVE_IMAGE_ID = "hover-pin-school-inactive";
export const HOVER_PIN_SCHOOL_INACTIVE_IMAGE_PATH: string = toImagePath(
  hoverPinSchoolInactiveImage,
);

// School level colors
export const SCHOOL_COLORS = {
  ELEMENTARY: "#6DA554",
  MIDDLE: "#8856B1",
  HIGH: "#D99131",
  K8: "#4A90D9",
} as const;

export const SHOW_ALL_FILTER: maplibregl.FilterSpecification = [
  "literal",
  true,
];
export const HIDE_FILTER = [
  "literal",
  false,
] as const satisfies maplibregl.FilterSpecification;

// Map style constants
export const DEFAULT_MAP_STYLE = MapStyle.DATA_VIZ;

/** Styles available in the map style selector (Dataviz, Dataviz dark, Satellite, Hybrid, Streets). */
export const SELECTABLE_MAP_STYLES: MapStyle[] = [
  MapStyle.DATA_VIZ,
  MapStyle.DATA_VIZ_DARK,
  MapStyle.SATELLITE,
  MapStyle.HYBRID,
  MapStyle.STREETS,
];

// Default map container dimensions
export const DEFAULT_MAP_CONTAINER_WIDTH = 800;
export const DEFAULT_MAP_CONTAINER_HEIGHT = 600;

// Default map settings
export const DEFAULT_CENTER: MapCoordinates = [-95.7129, 37.0902]; // USA center
export const DEFAULT_ZOOM = 4; // Zoom level to show entire USA

export const DEFAULT_MIN_ZOOM = 12; // Street level
export const DEFAULT_MAX_ZOOM = 22;
/** MapLibre layer maxzoom; +1 above tile source so layers stay visible at map max zoom */
export const DEFAULT_LAYER_MAX_ZOOM = 23;
export const VECTOR_TILE_LAYER_MAX_ZOOM_OFFSET = 1;
export const DEFAULT_MIN_ZOOM_FOR_DETAIL = 12; // Minimum zoom when centering on plot
export const FLY_TO_DURATION = 700; // Duration for map flyTo animation in milliseconds

// Default plots settings
export const DEFAULT_PLOT_COLOR = "#520313";
export const PROJECT_CLUSTER_COLOR = "#943C56";
export const PROJECT_READY_TO_CONFIRM_CLUSTER_COLOR = "#F28C28";
export const PROJECT_NEED_INFO_CLUSTER_COLOR = "#E5484D";
export const DEFAULT_PLOT_RADIUS = 4; // Default plot marker radius
export const DEFAULT_PLOT_STROKE_WIDTH = 2; // Default plot marker stroke width
export const ACTIVE_PLOT_RADIUS = 8; // Active plot marker radius
export const ACTIVE_PLOT_STROKE_WIDTH = 3; // Active plot marker stroke width
export const ACTIVE_PLOT_COLOR = "#520313"; // Active plot marker color
export const ACTIVE_PLOT_RING_COLOR = "#FFF"; // Active plot marker color
export const ACTIVE_PLOT_RING_1_RADIUS = 16; // First transparent ring radius
export const ACTIVE_PLOT_RING_2_RADIUS = 24; // Second transparent ring radius
export const ACTIVE_PLOT_RING_1_OPACITY = 0.6; // Opacity for transparent rings
export const ACTIVE_PLOT_RING_2_OPACITY = 0.5; // Opacity for transparent rings

// Marker label styles
export const SCHOOL_PIN_LABEL_HIDE_END_ZOOM = 11.5;
export const LABEL_PADDING_X = 4;
export const LABEL_PADDING_Y = 1;
export const LABEL_BORDER_RADIUS = 2;
export const LABEL_FONT_SIZE = 12;
export const LABEL_LINE_HEIGHT = 12;
export const LABEL_DROP_SHADOW_COLOR = "rgba(0, 0, 0, 0.16)";
export const LABEL_DROP_SHADOW_OFFSET: [number, number] = [0, 1];
export const LABEL_DROP_SHADOW_BLUR = 3;

// Polygon layer settings
/** Fill/line opacity when polygon is clicked */
export const POLYGONS_ACTIVE_STATE_FILL_OPACITY = 0.4;
export const POLYGONS_ACTIVE_STATE_LINE_OPACITY = 0.9;
export const POLYGONS_STROKE_WIDTH = 1.5;
export const POLYGONS_STROKE_COLOR = "#000000";
export const POLYGONS_DEFAULT_FILL_COLOR = "#B3C0C9";
export const POLYGONS_DEFAULT_STROKE_COLOR = "#7A8599";

/** School attendance boundary outline (Platform, FMS, custom school, previews). */
export const SCHOOL_BOUNDARY_STROKE: PolygonStrokeStyle = {
  color: "#1F2937",
  width: 2,
  opacity: 0.9,
};

// Active polygon styling
export const ACTIVE_POLYGON_FILL_COLOR = "#520313";
export const ACTIVE_POLYGON_STROKE_COLOR = "#52031366"; // 40% opacity

export const SHAPES_ACTIVE_FILL_OPACITY = 0.4;
export const SHAPES_ACTIVE_LINE_OPACITY = 1;

// Invited polygon styling
export const INVITED_POLYGON_COLOR = "#D8A52F";

// Polygon vertex and border styles
export const POLYGONS_VERTEX_RADIUS = 4;
export const POLYGONS_MIDPOINT_RADIUS = 3;
export const POLYGONS_VERTEX_COLOR = "#FFFFFF";
export const POLYGONS_VERTEX_STROKE_WIDTH = 3;
export const POLYGONS_VERTEX_STROKE_COLOR = "#520313";
export const POLYGONS_STROKE_DASH_ARRAY: [number, number] = [2, 2];
export const POLYGONS_STROKE_COLOR_ACTIVE = "#520313";
/** Screen-space hit tolerance for hover-insert along a polygon edge. */
export const EDGE_INSERT_HIT_TOLERANCE_PX = 12;
export const EDGE_INSERT_PREVIEW_SOURCE_ID = "draw-edge-insert-preview";
export const EDGE_INSERT_PREVIEW_LAYER_ID = "draw-edge-insert-preview-circle";

export const SHAPE_FILTER_MARKER = "shape_filter_marker";

export const DEFAULT_OFFSET: [number, number] = [0.001, 0.001];

export const DRAW_DELETE_KEYS = ["Delete", "Backspace"] as const;
export const DRAW_SELECT_MODES = ["simple_select", "direct_select"] as const;

export const EMPTY_FEATURE_COLLECTION: GeoJSON.FeatureCollection = {
  type: "FeatureCollection",
  features: [],
};

export const EMPTY_HIDDEN_TYPES: string[] = [];

export const MAP_STYLE_OPTIONS: MapStyleOption[] = [
  { imageSrc: lightPreview, label: "Light", style: MapStyle.DATA_VIZ },
  {
    imageSrc: darkPreview,
    label: "Dark",
    style: MapStyle.DATA_VIZ_DARK,
  },
  {
    imageSrc: satellitePreview,
    label: "Satellite",
    style: MapStyle.SATELLITE,
  },
  { imageSrc: hybridPreview, label: "Hybrid", style: MapStyle.HYBRID },
  { imageSrc: streetsPreview, label: "Streets", style: MapStyle.STREETS },
];
